import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Grid, TextField } from "@mui/material";
import Modal from "../../components/Modal/Modal";
import SimpleBackdrop from "../../components/Loading/SimpleBackdrop";
import { AlertInfo } from "../../components/Alerts/Alert";
import { api } from "../../services/api";
import { ProcessoType } from "../../types/ProcessoType";

type ObservacoesProcessoProps = {
    open: boolean
    setOpen: Dispatch<SetStateAction<boolean>>
    activeProcess: ProcessoType | null
    onSaved?: () => void
}

export default function ObservacoesProcesso({ open, setOpen, activeProcess, onSaved }: ObservacoesProcessoProps) {
    const [obsText, setObsText] = useState("");
    const [openLoad, setOpenLoad] = useState(false);

    useEffect(() => {
        if (open && activeProcess) {
            setObsText(activeProcess.obs_processuais || "");
        }
    }, [open, activeProcess]);

    async function handleSave() {
        if (!activeProcess) return;
        setOpenLoad(true);
        try {
            const response = await api.post("/updateprocesso", {
                id_processo: activeProcess.id_processo,
                obs_processuais: obsText,
            });
            if (response.data?.success) {
                AlertInfo({ icon: "success", title: "Observações salvas!" });
                if (onSaved) onSaved();
                setOpen(false);
            } else {
                AlertInfo({ icon: "error", title: response.data?.message || "Erro ao salvar" });
            }
        } catch {
            AlertInfo({ icon: "error", title: "Falha na conexão" });
        }
        setOpenLoad(false);
    }

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title="Observações Processuais"
            maxWidth="sm"
            zIndex={2222}
            buttonActions={[
                { color: "primary", text: "Salvar", handle: handleSave },
                { color: "error", text: "Cancelar", handle: () => setOpen(false) },
            ]}
        >
            <SimpleBackdrop open={openLoad} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <TextField
                        label="Observações Processuais"
                        multiline
                        minRows={4}
                        maxRows={12}
                        fullWidth
                        value={obsText}
                        onChange={(e) => setObsText(e.target.value)}
                        variant="outlined"
                    />
                </Grid>
            </Grid>
        </Modal>
    );
}
